require('./style.scss');
import EventEmitter from '../../helpers/EventEmmiter';

export default class FlagList extends EventEmitter{
    _class = 'flag-list';
    _node = null;
    _langs = null;

    constructor(wrapper, langs) {
        super();

        this._wrapper = wrapper;
        this._langs = langs;

        this._init();
    }

    _init() {
        const div = document.createElement('div');
        div.classList.add(this._class);

        div.append(this._createModal(this._langs));

        this._node = div;
    }

    _createObject(lang) {
        const object = document.createElement('object');
        object.classList.add('flag');
        object.setAttribute('type', 'image/svg+xml');
        object.setAttribute('data',  flagImgs[lang]);
    }

    _createModal(langs) {
        const div = document.createElement('div');
        div.classList.add('popover-content');

        const ul = document.createElement('ul');
        ul.classList.add('change-language-popup');

        langs.forEach((lang)  => {
            const li = document.createElement('li');
            li.classList.add(lang);
            li.dataset.lang = lang;
            li.addEventListener('click', (event) => { 
                event.preventDefault();
                event.stopPropagation();

                this._fireEvent('onChooseLang', lang);
                this.destroy();
            });

            ul.append(li);
        });

        div.append(ul);

        return div;
    }

    show = async () => {
        if(!this._wrapper.contains(this._node)) this._wrapper.appendChild(this._node);
    }

    hide(){
        if(this._wrapper.contains(this._node)) this._wrapper.removeChild(this._node);
    }

    applyClass(className){
        this._node.classList.add(className);
    }

    destroy(){
        if(this._node && this._node.parentNode === this._wrapper) this._wrapper.removeChild(this._node);

        return null;
    }
}


